import { Mutation } from '@apollo/client/react/components';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React from 'react';
import { CHANGE_CURATOR_ROLE } from '../../../helpers/graphql/roles';

class ChangeRoles extends React.Component {
  state = {
    open: false,
  };

  handleCheckboxChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  newNotification(notification) {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      this.props.enqueueSnackbar(notification.message, { variant });
    }
  }

  render() {
    const { isCurator, author, isVideo } = this.props;
    const { open } = this.state;

    const roleName = isVideo ? 'video curator' : 'team member';

    if (isCurator) {
      return (
        <Mutation
          mutation={CHANGE_CURATOR_ROLE}
          variables={{
            user: author,
            isCurator: isVideo ? undefined : false,
            isVideo: isVideo ? false : undefined,
          }}
        >
          {(removeCurator, data) => {
            if (
              data &&
              data.data &&
              data.data.updateUserRoles &&
              open === true
            ) {
              this.newNotification({
                success: data.data.updateUserRoles.success,
                message: data.data.updateUserRoles.message,
              });
              this.setState({ open: false });
            }
            return (
              <>
                <MenuItem onClick={this.handleClickOpen}>
                  Remove {roleName} role
                </MenuItem>
                <Dialog
                  open={open}
                  onClose={this.handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    Remove {roleName} role?
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Are you sure that you want to revoke {roleName} rights for
                      @{author}?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                      Cancel
                    </Button>
                    <Button
                      onClick={removeCurator}
                      color="primary"
                      variant="contained"
                      autoFocus
                    >
                      Remove {roleName} role
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            );
          }}
        </Mutation>
      );
    }
    return (
      <Mutation
        mutation={CHANGE_CURATOR_ROLE}
        variables={{
          user: author,
          isCurator: isVideo ? undefined : true,
          isVideo,
        }}
      >
        {(makeCurator, data) => {
          if (data && data.data && data.data.updateUserRoles && open === true) {
            this.newNotification({
              success: data.data.updateUserRoles.success,
              message: data.data.updateUserRoles.message,
            });
            this.setState({ open: false });
          }
          return (
            <>
              <MenuItem onClick={this.handleClickOpen}>
                Make {roleName}
              </MenuItem>
              <Dialog
                open={open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Promote user to {roleName} member?
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure that you want to give the user @{author}{' '}
                    {roleName} rights?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose} color="primary">
                    Cancel
                  </Button>
                  <Button
                    onClick={makeCurator}
                    color="primary"
                    variant="contained"
                    autoFocus
                  >
                    Do it!
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          );
        }}
      </Mutation>
    );
  }
}

ChangeRoles.propTypes = {
  author: PropTypes.string.isRequired,
  isCurator: PropTypes.bool.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
};

export default withSnackbar(ChangeRoles);
